module.exports = __webpack_public_path__ + "img/34_22.6dd9bad9.png";